export type FontFamily = "Arial" | "Georgia" | "Impact" | "Poppins" | "Roboto" | "Times New Roman";
export const FontFamilyValues: FontFamily[] = ["Arial", "Georgia", "Impact", "Poppins", "Roboto", "Times New Roman"];
